import { combineReducers } from "redux"
import { routerReducer } from "react-router-redux"
import Common from "appRedux/slices/common"
// import Config from "appRedux/slices/config"
import UsersListReducer from "appRedux/slices/usersList"
import CurrentUser from "appRedux/slices/currentUser"
import Application from "appRedux/slices/application"
import Permissions from "appRedux/slices/permissions"
import Roles from "appRedux/slices/rolesList"

const reducers = combineReducers({
  currentUser: CurrentUser,
  routing: routerReducer,
  common: Common,
  appUser: UsersListReducer,
  application: Application,
  roles: Roles,
  permissions: Permissions,
})

export default reducers
